import React, { useState, useEffect } from 'react';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import entete from 'data/entetes';
import { Row, Col } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import { getCaisse } from 'data/Finance/caisse';

const columns = [
  {
    accessorKey: 'id',
    header: 'ID',
    meta: {
      headerProps: { className: 'text-900' },
    },
  },
  {
    accessorKey: 'date',
    header: 'Date',
    accessorFn: row => {
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(new Date(row.date));
    },
    meta: {
      headerProps: { className: 'text-900' },
    },
  },
  {
    accessorKey: 'designation',
    header: 'Désignation',
    meta: {
      headerProps: { className: 'text-900', style: { minWidth: '200px' } },
    },
  },
  {
    accessorKey: 'source',
    header: 'Source',
    meta: {
      headerProps: { className: 'text-900' },
    },
  },
  {
    accessorKey: 'refSource',
    header: 'refSource',
    meta: {
      headerProps: { className: 'text-900' },
    },
  },
  {
    accessorKey: 'dateSource',
    header: 'DateSource',
    accessorFn: row => {
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(new Date(row.dateSource));
    },
    meta: {
      headerProps: { className: 'text-900' },
    },
  },
  {
    accessorKey: 'secteur',
    header: 'Secteur',
    meta: {
      headerProps: { className: 'text-900' },
    },
  },
  {
    accessorKey: 'intervenant',
    header: 'Intervenant',
    meta: {
      headerProps: { className: 'text-900' },
    },
  },
  {
    accessorKey: 'debit',
    header: 'Débit',
    accessorFn: row => {
      return row.debit?.toFixed(3) || '0.000';
    },
    meta: {
      headerProps: { className: 'text-900' },
    },
  },
  {
    accessorKey: 'credit',
    header: 'Credit',
    accessorFn: row => {
      return row.credit?.toFixed(3) || '0.000';
    },
    meta: {
      headerProps: { className: 'text-900' },
    },
  },
];

const TabTitle = ({ title, value, percentage, progress }) => (
  <div className="p-2 pe-4 text-start cursor-pointer">
    <h6 className="text-800 fs-11 text-nowrap">{title}</h6>
    <h5 className="text-800">{value}</h5>
    {/* <Flex alignItems="center">
      <FontAwesomeIcon
        icon={progress ? 'caret-up' : 'caret-down'}
        className={progress ? 'text-success' : 'text-warning'}
      />
      <h6 className={`fs-11 mb-0 ms-2 ${progress ? 'text-success' : 'text-warning'}`}>
        {percentage}
      </h6> 
    </Flex>*/}
  </div>
);

function EnteteTable({ data, type }) {
  const table = useAdvanceTable({
    columns,
    data: data && type === 'Tous' ? data : data.filter(item => item.typeCaisse === type),
    sortable: true,
    selection: true,
    pagination: true,
    initialState: 20,
    perPage: 20,
  });

  const handleRowClick = row => {
    console.log('Row clicked:', row.original);
    // Add your custom logic here
  };
  const optionPagesPerPage = [20, 50, 100];
  return (
    <AdvanceTableProvider {...table}>
      <Row className="flex-start-center mb-3">
        <Col xs={2} className="float-start mt-2 ms-3">
          <AdvanceTableSearchBox />
        </Col>
      </Row>
      <AdvanceTable
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs-10 mb-0 overflow-hidden',
        }}
        onRowClick={handleRowClick}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowInfo
          navButtons
          rowsPerPageSelection
          rowsPerPageOptions={optionPagesPerPage}
        />
      </div>
    </AdvanceTableProvider>
  );
}

export default EnteteTable;
